import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";
var _excluded = ["icon"];
import * as React from "react";
import classNames from "classnames";
import QuestionCircleOutlined from "@ant-design/icons/QuestionCircleOutlined";
import { FormContext } from "./context";
import { useLocaleReceiver } from "./../../LocaleProvider/LocaleReceiver";
import Tooltip from "../../Tooltip";
import Col from "../../Col";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function toTooltipProps(tooltip) {
  if (!tooltip) {
    return null;
  }
  if (_typeof(tooltip) === "object" && ! /*#__PURE__*/React.isValidElement(tooltip)) {
    return tooltip;
  }
  return {
    title: tooltip
  };
}
var FormItemLabel = function FormItemLabel(_ref) {
  var prefixCls = _ref.prefixCls,
    label = _ref.label,
    htmlFor = _ref.htmlFor,
    labelCol = _ref.labelCol,
    labelAlign = _ref.labelAlign,
    colon = _ref.colon,
    required = _ref.required,
    requiredMark = _ref.requiredMark,
    tooltip = _ref.tooltip;
  var _useLocaleReceiver = useLocaleReceiver("Form"),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
    formLocale = _useLocaleReceiver2[0];
  if (!label) return null;
  return /*#__PURE__*/_jsx(FormContext.Consumer, {
    children: function children(_ref2) {
      var _classNames2;
      var vertical = _ref2.vertical,
        contextLabelAlign = _ref2.labelAlign,
        contextLabelCol = _ref2.labelCol,
        labelWrap = _ref2.labelWrap,
        contextColon = _ref2.colon;
      var mergedLabelCol = labelCol || contextLabelCol || {};
      var mergedLabelAlign = labelAlign || contextLabelAlign;
      var labelClsBasic = "".concat(prefixCls, "-item-label");
      var labelColClassName = classNames(labelClsBasic, mergedLabelAlign === "left" && "".concat(labelClsBasic, "-left"), mergedLabelCol.className, _defineProperty({}, "".concat(labelClsBasic, "-wrap"), !!labelWrap));
      var labelChildren = label;
      // Keep label is original where there should have no colon
      var computedColon = colon === true || contextColon !== false && colon !== false;
      var haveColon = computedColon && !vertical;
      // Remove duplicated user input colon
      if (haveColon && typeof label === "string" && label.trim() !== "") {
        labelChildren = label.replace(/[:|：]\s*$/, "");
      }

      // Tooltip
      var tooltipProps = toTooltipProps(tooltip);
      if (tooltipProps) {
        var _tooltipProps$icon = tooltipProps.icon,
          icon = _tooltipProps$icon === void 0 ? /*#__PURE__*/_jsx(QuestionCircleOutlined, {}) : _tooltipProps$icon,
          restTooltipProps = _objectWithoutProperties(tooltipProps, _excluded);
        var tooltipNode = /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({}, restTooltipProps), {}, {
          children: /*#__PURE__*/React.cloneElement(icon, {
            className: "".concat(prefixCls, "-item-tooltip"),
            title: ""
          })
        }));
        labelChildren = /*#__PURE__*/_jsxs(_Fragment, {
          children: [labelChildren, tooltipNode]
        });
      }
      var labelClassName = classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-item-required"), required), _defineProperty(_classNames2, "".concat(prefixCls, "-item-no-colon"), !computedColon), _classNames2));
      return /*#__PURE__*/_jsx(Col, _objectSpread(_objectSpread({}, mergedLabelCol), {}, {
        className: labelColClassName,
        children: /*#__PURE__*/_jsx("label", {
          htmlFor: htmlFor,
          className: labelClassName,
          title: typeof label === "string" ? label : "",
          children: labelChildren
        })
      }));
    }
  }, "label");
};
export default FormItemLabel;